import { FieldName, MinMaxProps } from './types';

type MinMaxConfig<T> = [field: FieldName, prop: keyof T][];

export const minMaxFieldsConfig: MinMaxConfig<MinMaxProps> = [
  [FieldName.priceFrom, 'priceMin'],
  [FieldName.priceTo, 'priceMax'],
  [FieldName.areaFrom, 'areaMin'],
  [FieldName.areaTo, 'areaMax'],
  [FieldName.floorFrom, 'floorMin'],
  [FieldName.floorTo, 'floorMax'],
];
